import { WebUtils } from "@dp/web";
import { Root as RootS } from "@dp/state";
export default new RootS(WebUtils);